export interface MarkdownSection {
  content: string;
  found: boolean;
}

export interface MarkdownHeading {
  id: string;
  title: string;
}

/**
 * Extracts a named HTML-comment-delimited section from a Markdown document.
 */
export const extractMarkdownSection = (
  markdown: string,
  sectionName: string,
): MarkdownSection => {
  const startMarker = `<!-- ${sectionName}:start -->`;
  const endMarker = `<!-- ${sectionName}:end -->`;
  const startIndex = markdown.indexOf(startMarker);

  if (startIndex === -1) {
    return { content: "", found: false };
  }

  const contentStartIndex = startIndex + startMarker.length;
  const endIndex = markdown.indexOf(endMarker, contentStartIndex);

  if (endIndex === -1) {
    return { content: "", found: false };
  }

  return {
    content: markdown.slice(contentStartIndex, endIndex).trim(),
    found: true,
  };
};

/**
 * Builds stable IDs for level-two Markdown headings so a rendered document can be navigated by anchors.
 */
export const extractMarkdownHeadings = (markdown: string): MarkdownHeading[] => {
  const headingPattern = /^##\s+(.+?)(?:\s+#+)?\s*$/gm;
  const headings: MarkdownHeading[] = [];
  let match = headingPattern.exec(markdown);

  while (match) {
    headings.push({
      id: `about-section-${headings.length + 1}`,
      title: match[1].trim(),
    });
    match = headingPattern.exec(markdown);
  }

  return headings;
};

export const addMarkdownHeadingIds = (
  html: string,
  headings: MarkdownHeading[],
): string => {
  let headingIndex = 0;

  return html.replace(/<h2>/g, () => {
    const heading = headings[headingIndex];
    headingIndex += 1;
    return heading ? `<h2 id="${heading.id}">` : "<h2>";
  });
};
